import { gql } from '@apollo/client/core';

export default gql`
  query Suggestion {
    getTeamUsers {
      _id
      firstName
      lastName
      entities {
        _id
      }
    }
  }
`;
